import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("Uncaught render error", error, info);
  }
  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-lg mx-auto mt-16 p-6 bg-white border-2 border-[#E4DDD3] rounded-2xl text-center" data-testid="error-boundary">
          <div className="text-lg font-bold text-[#1C2024]">Something went wrong on this page.</div>
          <p className="text-[#4A525A] mt-2">Please try again. Your saved data is safe.</p>
          <div className="mt-4 flex gap-2 justify-center">
            <a href="/" className="pod-focus bg-[#C85A32] hover:bg-[#B24C28] text-white font-bold py-2 px-4 rounded-xl">Home</a>
            <button onClick={this.handleReset} className="pod-focus border-2 border-[#E4DDD3] hover:border-[#C85A32] text-[#1C2024] font-bold py-2 px-4 rounded-xl">Try again</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
